import React from 'react';

// 容器组件
const NotFound: React.FC = () => {
  return (
    <div>
      NotFound
    </div>
  );
};

export default NotFound;
